module.exports = __webpack_public_path__ + "static/img/gimg03.19cfcdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mui/img/gimg03.png
// module id = IPCP
// module chunks = 147